// extracted by mini-css-extract-plugin
export default {"footerCancelButton":"_6wllM","contentWrapper":"p172M","offerContainer":"_34vbn","offerLink":"_3O2r1","offerModal":"_15c1i","noAlignment":"CyZY_"};